import React, { useEffect, useState } from "react";
import { bool, shape, string } from "prop-types";
import { connect, useDispatch } from "react-redux";
import { ResponsiveHeader } from "pages/_components/header";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { Col } from "react-bootstrap";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";

import { push } from "connected-react-router";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";

import { selectors as onboardingSelectors, actions as onboardingActions } from "reducers/onboarding";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import * as config from "util/config";

const StepScanDocumentSuccessMigration = ({ isMobile, documentData, exchangeToken }) => {
    const dispatch = useDispatch();
    const [skipSelfie, setSkipSelfie] = useState(false);

    useEffect(() => {
        setSkipSelfie(config.getBoolean("onb.skipSelfie"));
    }, [dispatch]);

    const onContinue = () => {
        if (skipSelfie === false) {
            dispatch(push("/migration/StepCaptureSelfie"));
        } else if (documentData && documentData.cuil) {
            dispatch(onboardingActions.getPersonalData(documentData.cuil, exchangeToken));
        }
    };

    return (
        <>
            {isMobile && <ResponsiveHeader ticket id="onboarding.noUser.title" />}
            <MainContainer>
                {!isMobile && <Head title="onboarding.noUser.title" />}

                <div className="above-the-fold">
                    <Col xs={12} md={8} mdOffset={2}>
                        <h1 className="text-center">
                            <CustomText text={i18nUtils.get("", "¡DNI ingresado exitosamente!")} />
                        </h1>
                    </Col>
                    <div className="illustration text-center">
                        <Image src="figma/illustrations/onboarding4.svg" className="svg-image logo" />
                    </div>
                    <Col xs={12} md={8} mdOffset={2}>
                        <div className="box box-border-soft">
                            {skipSelfie === false ? (
                                <CustomText
                                    text={i18nUtils.get(
                                        "",
                                        "Ahora vamos a continuar con el reconocimiento facial para validar tu identidad.",
                                    )}
                                />
                            ) : (
                                <CustomText
                                    text={i18nUtils.get(
                                        "",
                                        "Ahora que sabemos que sos vos, vamos a consultar algunos datos personales.",
                                    )}
                                />
                            )}
                        </div>
                    </Col>
                    <div className="form-actions">
                        <Button
                            className="continue-btn"
                            bsStyle="primary"
                            label="global.continue"
                            loading={false}
                            onClick={onContinue}
                            defaultLabelText="Continuar"
                        />
                    </div>
                </div>
            </MainContainer>
        </>
    );
};

StepScanDocumentSuccessMigration.propTypes = {
    isMobile: bool.isRequired,
    documentData: shape({}).isRequired,
    exchangeToken: string.isRequired,
};

const mapStateToProps = (state) => ({
    documentData: onboardingSelectors.getDocumentData(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
});

export default connect(mapStateToProps)(StepScanDocumentSuccessMigration);
